/**
 * Third-party origins used by the app (not overridden by REACT_APP_API_BASE).
 */

/** Production web origin (display URLs, absolute links when not using `apiUrl`). */
export const ELECTRONVISUAL_ORIGIN = "https://electronvisual.org";

/** Protein–ligand docking (AutoDock Vina in the browser). */
export const LCBCDOCK_ORIGIN = "https://lcbc-client.apps.johnseong.com";

export const HELPER_API_ORIGIN = "https://helper.electronvisual.org";

export function helperSmilesToIupacUrl(smilesUrlEncoded: string): string {
  return `${HELPER_API_ORIGIN}/api/smiles_to_iupac/${smilesUrlEncoded}`;
}

/** Send with `authHeaders(user)` — the server only answers for the
 *  caller's own verified uid and takes the e-mail from the token. */
export function paymentsSubscriberDataUrl(uid: string): string {
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  return `${base}/api/get_subscriber_data/${encodeURIComponent(uid)}`;
}

export function paymentsCreateCheckoutSessionUrl(): string {
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  return `${base}/api/create-checkout-session`;
}

export function paymentsCreatePortalSessionUrl(): string {
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  return `${base}/api/create-portal-session`;
}
